import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { checkTerminalConnectivity, TerminalConnectivity } from "@/utils/vue-helpers/common";
import { PaymentMethodTypeToTranslatedString } from "@/utils/vue-helpers/pos-config";
import { computed, defineComponent, ref } from "vue";
export default defineComponent({
  name: "SettingsItem",
  props: {
    settingInfo: {
      required: true,
      type: Object
    }
  },
  setup: function setup(props) {
    var terminalConnection = ref(null);
    var formData = computed(function () {
      return props.settingInfo;
    });

    var toggleStatus = function toggleStatus(status) {
      formData.value.used = status;
    };

    var isUsed = computed(function () {
      return formData.value.used;
    }); // Function to check selected terminal connectivity

    function checkSelectedTerminal() {
      return _checkSelectedTerminal.apply(this, arguments);
    }

    function _checkSelectedTerminal() {
      _checkSelectedTerminal = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var terminalId;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Lets check terminal connectivity if there is any
                terminalId = formData.value.terminal;

                if (!terminalId) {
                  _context.next = 6;
                  break;
                }

                terminalConnection.value = TerminalConnectivity.Loading;
                _context.next = 5;
                return checkTerminalConnectivity(terminalId);

              case 5:
                terminalConnection.value = _context.sent;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _checkSelectedTerminal.apply(this, arguments);
    }

    return {
      formData: formData,
      toggleStatus: toggleStatus,
      isUsed: isUsed,
      PaymentMethodTypeToTranslatedString: PaymentMethodTypeToTranslatedString,
      checkSelectedTerminal: checkSelectedTerminal,
      terminalConnection: terminalConnection,
      TerminalConnectivity: TerminalConnectivity
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this.formData.terminal) {
                _context2.next = 3;
                break;
              }

              _context2.next = 3;
              return _this.checkSelectedTerminal();

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
});